import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/clohea-white-logo.svg'



export default /*@__PURE__*/_defineComponent({
  __name: 'CloheaLogo',
  props: {
    animate: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'clohea-logo',
      {
        'shake': __props.animate
      },
    ])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: "Clohea Logo",
      class: "w-100",
      "data-testid": "cloheaLogo"
    }, null, -1)
  ]))], 2))
}
}

})